<!--
  '0'//项目 1成本中心 2 科目码 3 place地标
  4 出差申请单列表  5机票申请退票 非自愿取消原因列表/企业原因
  6审批规则列表
-->
<template>
  <div>
    <van-popup
      v-model="isShow"
      position="right"
      :close-on-popstate="true"
      :get-container="getContainer"
      class="full-width full-height"
    >
      <div class="check-list full-height">
        <ld-header
          :title="titles"
          @click-left="toggle"
        />

        <van-search
          placeholder="请输入搜索关键词"
          v-model.lazy="value"
        />

        <van-cell
          v-if="type == 3"
          :title="params.cityName"
          icon="location-o"
          @click="chooseCity"
        />

        <div class="check-list-wrapper">
          <mescroll-vue
            class="list-box"
            ref="mescroll"
            :down="down"
          >
            <van-row
              class="font16 font-lg text-left"
              v-show="type==0||type==1"
            >
              <van-col span="2" />
              <van-col span="7">
                代码
              </van-col>
              <van-col span="15">
                名称
              </van-col>
            </van-row>
            <!-- 出差申请单 -->
            <div v-if="type == 4">
              <trip-list
                v-for="(info, index) in list"
                :item="info"
                :key="index"
                @click.native="getResults(info)"
              />
            </div>
            <div v-else>
              <check-list
                v-for="(info, index) in list"
                :item="info"
                :key="index"
                @click.native="getResults(info)"
              />
            </div>

            <ld-no-more />
          </mescroll-vue>
        </div>

        <!-- 城市 -->
        <city
          ref="city"
          :sys-type="0"
          :city-type="1"
          @selected="getParams"
        />
      </div>
    </van-popup>
  </div>
</template>

<script>
import MescrollVue from 'mescroll.js/mescroll.vue'
import City from 'Common/city'
import {Search, Popup, Cell} from 'vant'
import {formatDate} from 'Utils/dateUtil'
import ldNoMore from 'Common/ldNoMore'
import checkList from './components/checkList'
import tripList from './components/tripList'

export default {
  name: 'CheckList',
  components: {
    City,
    MescrollVue,
    [Popup.name]: Popup,
    [Search.name]: Search,
    [Cell.name]: Cell,
    ldNoMore, checkList, tripList
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    type: {
      type: [String,Number],
      default: '0' //项目 1成本中心 2 科目码 3 place地标 4 出差申请单列表 5机票申请退票 非自愿取消原因 /企业原因 6审批规则列表
    },
    params: {
      type: [Object,String],
      default: function() {
        return {}
      }
    },
    element:{
      type:String,
      default:''
    }
  },
  data() {
    return {
      down:{ use: false },
      isShow: false,
      value: '', //检索
      searchList: [],
      list: [],
      Projectname:[]
    }
  },
  computed: {
    titles() {
      let arr = [
        '选择项目',
        '选择成本中心',
        '选择科目码',
        '选择地址',
        '选择出差申请单',
        '选择原因',
        '选择规则'
      ]
      if (this.title) {
        return this.title
      }
      return arr[this.type]
    }
  },
  methods: {
    getResults(info) {
      this.Projectname = info
      if (this.type == 0) {
        this.$store.commit('travelInfo/project', info)
      } else if (this.type == 1) {
        this.$store.commit('travelInfo/costCenter', info)
      } else if (this.type == 2) {
        this.$store.commit('travelInfo/subjectCode', info)
      }
      this.$emit('selected', info)
      this.$store.commit('tk/businesssingle', info.routeBookList) //存一份选中出差单的信息
      this.toggle()
    },
    async getList(val) {
      let arr = [
        {
          url: 'common/projectList',
          params: {
            projectId: '',
            travelEmpId: '',
            txEmpIds: ''
          }
        },
        {
          url: 'common/costCenterFindList',
          params: {
            projectId: '',
            travelEmpId: '',
            txEmpIds: ''
          }
        },
        {
          url: 'common/vipJcsjbGetList',
          params: {
            lb: '11704'
          }
        },
        {
          url: 'baidu/baiduPlace',
          params: {
            cityName: this.params.cityName,
            keywords: val || this.params.keywords
          }
        },
        {
          url: 'common/vipCcsqdGetListForChoose',
          params: {
            pageNum: '1', //默认显示第一页
            count: '500', //每页显示10条数据
            proType: this.params.cplx,
            dateBegin: formatDate(new Date(), -90).date, //  日期开始
            dateEnd: formatDate(new Date()).date //  日期结束
          }
        },
        {
          url: 'common/getBClass',
          params: {
            parNo: this.params
          }
        },
        {
          url: 'approval/spgzFindList',
          params: {}
        }
      ]
      this.list = []
      let res = await this.$api[arr[this.type].url](arr[this.type].params)
      let cache = res.data || {}
      if (Array.isArray(cache)) {
        this.searchList = cache
        this.list = cache
      } else {
        this.searchList = cache.list || []
        this.list = cache.list || []
      }
    },
    chooseCity() {
      this.$refs.city.toggle()
    },
    getParams(info) {
      this.params.cityName = info.cityName
      this.params.keywords = info.cityName
    },
    // 返回一个特定的 DOM 节点，作为挂载的父节点
    getContainer() {
      if(this.element){
        return document.querySelector(this.element)
      }
      return ''
    },
    toggle(obj) {
      this.isShow = !this.isShow
      if (this.isShow) {
        if(obj){
          Object.assign(this, obj)
        }
        this.getList()
      } else {
        this.value = ''
      }
    },
    getReason(parNo) {
      this.isShow = !this.isShow
      if (this.isShow) {
        this.$api['common/getBClass']({
          parNo: parNo
        }).then(res => {
          let cache = res.data || {}
          if (Array.isArray(cache)) {
            this.searchList = cache
            this.list = cache
          } else {
            this.searchList = cache.list || []
            this.list = cache.list || []
          }
        }).catch(() => {
        })
      } else {
        this.value = ''
      }
    },
  },
  watch: {
    params () {
      this.getList()
    },
    value(val) {
      if(this.type==3){
        this.getList(val)
      }else{
        //检索
        this.list = this.searchList.filter(item => {
          if (
            item.costCenterName && item.costCenterName.indexOf(val) > -1 ||
            item.costCenterCode && item.costCenterCode.indexOf(val) > -1 ||
            item.reasonDesc && item.reasonDesc.indexOf(val) > -1 ||
            item.projectCode && item.projectCode.indexOf(val) > -1 ||
            item.projectName && item.projectName.indexOf(val) > -1 ||
            item.svalue && item.svalue.indexOf(val) > -1 ||
            item.name && item.name.indexOf(val) > -1 ||
            item.district && item.district.indexOf(val) > -1 ||
            item.gzmc && item.gzmc.indexOf(val) > -1 ||

            item.ccsqdNo && item.ccsqdNo.indexOf(val) > -1 ||
            item.mdd && item.mdd.indexOf(val) > -1 ||
            item.ccr && item.ccr.indexOf(val) > -1
          ) {
            return true
          } else {
            return false
          }
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.check-list {
  .check-list-wrapper {
    width: 100%;
    height: calc(100vh - 100px);
    overflow: hidden;
  }
  .list-box {
    padding: 0 10px;
    .check-item {
      margin-top: 10px;
    }
  }
}
</style>
